const getters = {
  menus: state => state.permission.menus,
  buttons: state => state.permission.buttons,
  routers: state => state.permission.routers,
  userInfo: state => state.user.userInfo,
  isCollapse: state => state.leftAside.isCollapse,
  leftAsideShow: state => state.leftAside.leftAsideShow,
  commonInfo: state => state.user.commonInfo, // 快递常用联系人
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js